export const setCanonical = (url) => {
  let link = !!document.querySelector("link[rel='canonical']")
    ? document.querySelector("link[rel='canonical']")
    : document.createElement("link");
  link.setAttribute("rel", "canonical");
  link.setAttribute("href", url);
  document.head.appendChild(link);
};

export const summonerURL = (region, summoner) =>
  `/${region}/${summoner.replace(/\s+/g, "").toLowerCase()}`;

export const summonerURLMulti = (region, summoner) => {
  if (summoner.indexOf(",") > 0)
    return `/lol/multi/${region}/${summoner
      .replace(/\s+/g, "")
      .toLowerCase()
      .split(",")
      .join("-")}`;
  else return `/${region}/${summoner.replace(/\s+/g, "").toLowerCase()}`;
};
